export default {
  'roleDetail.title': 'Role Detail',
  'roleEdit.createRole.title': 'New Role',
  'roleEdit.editRole.title': 'Edit Role',
  'roleEdit.saveRole': 'Save Role',
  'roleEdit.section.generalInformation': 'General Information',
  'roleEdit.section.accessPermissions': 'Access Permissions',
  'roleEdit.section.datePermissions': 'Data Permissions',
  'roleEdit.section.members': 'Employees',
  'roleEdit.field.name': 'Role Name',
  'roleEdit.field.foreign_name': 'Role Foreign Name',
  'roleEdit.field.permission': 'Permission',
  'roleEdit.field.dataPermission': 'Data Permission',
  'roleEdit.field.is_system': 'Is System Role?',
  'roleEdit.field.enforeClockInBeforeAccess': 'Must clock in before accessing POS App',
  'roleEdit.field.enforeCloseAllOrdersClockOut': 'Must close all orders before clocking out',
  'roleEdit.field.enableRoleRetainCash': 'Allow this role to retain cash',
  'roleEdit.field.deductCreditCardTips': 'Deduct credit card tips',
  'roleEdit.field.deductNetSales': 'Deduct Dine-in net sales',
  'roleEdit.cardTips': 'credit card tips',
  'roleEdit.netSales': 'Dine-in net sales',
  'roleEdit.field.enableRoleRetainCash.description': `
    Tip: If toggle is on, it will display the cash receipts due to the restaurant on Daily Closeout Report for employees assigned this role,
    to help settle cash between the restaurant and employees.
  `,
  'roleEdit.houseCash.base': `Tip: House cash = Cash Total - (Cash Tips + Card Tips + Other Tips)`,
  'roleEdit.name.errors.empty': 'Please input role name',
  'roleEdit.foreign_name.errors.empty': 'Please Input Role Foreign Name',
  'roleEdit.permission.errors.empty': 'Please select permissions',
  'roleEdit.is_system.errors.empty': 'Please figure out if The role Is system level',
  'roleEdit.create_success': 'Successfully created role',
  'roleEdit.update_success': 'Successfully updated role',
  'roleEdit.table_service.restrict':
    '(This category is only applicable when the restaurant type is opted to “table service“)',
  'roleEdit.search.placeholder': 'Search by name or phone number',
  'roleEdit.allOrders.desc':
    'Without this permission, individuals can only see their own Closed and Authorized orders from the past 24 hours.',
  'roleEdit.manuallyEnterWeight.desc':
    'With this permission, individuals can click on Manually Enter Weight when scale is connected.',
};
